module.exports = __webpack_public_path__ + "img/xpeng-logo.9c56b3c7.png";